export default {
  isMagenta: process.env.VUE_APP_SITE === 'Magenta',
  healthCheckNumbers: ['12145660087']
}
